import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    FormGroup,
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CommonHeader from "components/Headers/CommonHeader.js";
import { getTermsAndConditions, saveTermsAndConditions } from "api/ApiServices";
import Swal from "sweetalert2";
import { FaRegFileAlt } from "react-icons/fa";
const TermsConditions = () => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTermsAndConditions();
    }, []);

    const fetchTermsAndConditions = async () => {
        console.log("fetchTermsAndConditions");
        try {
            setLoading(true);
            const response = await getTermsAndConditions();
            console.log("Full response:", response);

            // ✅ FIX: Check the correct response structure
            if (response?.success) {
                // Get content from response.data.content
                const policyContent = response?.data?.content || "";
                console.log("Content:", policyContent);
                setContent(policyContent);
            } else {
                setContent("");
                console.log("No terms found or error:", response?.message);
            }
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
            setContent("");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            if (!content.trim()) {
                Swal.fire("Error", "Terms and Conditions content cannot be empty", "error");
                return;
            }

            setLoading(true);

            // ✅ FIX: Send the correct payload structure
            // Option 1: If backend expects 'content'
            const payload = {
                title: "Terms and Conditions",
                content: content
            };

            // Option 2: If backend expects 'tc_content' (uncomment if needed)
            // const payload = {
            //     title: "Terms and Conditions",
            //     tc_content: content
            // };

            console.log("Saving payload:", payload);

            const response = await saveTermsAndConditions(payload);
            console.log("Save response:", response);

            if (response?.success) {
                Swal.fire(
                    "Success",
                    response?.message || "Terms and Conditions updated successfully",
                    "success"
                );
                // Refresh the data after save
                await fetchTermsAndConditions();
            } else {
                Swal.fire(
                    "Error",
                    response?.message || "Something went wrong",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error saving terms and conditions:", error);

            const errorMessage = error?.response?.data?.message ||
                error?.message ||
                "Failed to save terms and conditions";

            Swal.fire("Error", errorMessage, "error");
        } finally {
            setLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
        ],
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "image",
    ];

    return (
        <>
            <CommonHeader />
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="bg-transparent py-3 py-sm-4 px-3 px-sm-4">
                                <Row className="align-items-center justify-content-between">
                                    <Col xs="12" sm="auto" className="mb-2 mb-sm-0">
                                        <h3 className="mb-0 text-dark font-weight-700">
                                            <FaRegFileAlt
                                                className="button-primary-color mr-2"
                                                size={20}
                                                style={{ verticalAlign: "middle" }}
                                            /> Manage Terms and Conditions
                                        </h3>
                                    </Col>
                                    <Col xs="12" sm="auto">
                                        <Button
                                            color="primary"
                                            onClick={handleSave}
                                            disabled={loading}
                                            size="md"
                                            className="px-4 bg-button-gradient-primary button-secondary border-0 w-100"
                                            style={{ borderRadius: "8px" }}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin mr-2" />
                                                    Saving...
                                                </>
                                            ) : (
                                                "Save Changes"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="px-3 px-sm-4 py-3 py-sm-4">
                                <FormGroup className="mb-0">
                                    <div className="quill-editor-wrapper">
                                        <ReactQuill
                                            theme="snow"
                                            value={content}
                                            onChange={setContent}
                                            modules={modules}
                                            formats={formats}
                                            placeholder="Write terms and conditions content here..."
                                        />
                                    </div>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default TermsConditions;